export const SCHEDULE_TAG = 'Schedule' as const